import { FunctionComponent } from 'react';

import ConditionalWrapperProps from './ConditionalWrapper.types';

const ConditionalWrapper: FunctionComponent<ConditionalWrapperProps> = ({
  condition,
  wrapper,
  children,
}) => (condition ? wrapper(children) : <>{children}</>);

export default ConditionalWrapper;
